/**
 * The markets Crux captures in, and the languages it asks in.
 *
 * Here rather than in setup's brand step, where they were first written,
 * because the top bar, the library, research and the question panel all name a
 * market too — and a component reaching into a screen for a list pulled that
 * screen's code into the first load.
 */

/** Markets we capture in. Kept short on purpose: each one is a real cost. */
export const COUNTRIES = [
  { code: "IN", label: "India" },
  { code: "US", label: "United States" },
  { code: "GB", label: "United Kingdom" },
  { code: "DE", label: "Germany" },
  { code: "AE", label: "United Arab Emirates" },
  { code: "SG", label: "Singapore" },
  { code: "BR", label: "Brazil" },
] as const;

/*
 * Exported alongside the markets, so every screen that asks for a language
 * offers the same set. Two lists would drift, and the day they did a prompt
 * would be created in a language the capture side has never heard of.
 */
export const LANGUAGES = [
  { code: "en", label: "English" },
  { code: "hi", label: "Hindi" },
  { code: "de", label: "German" },
  // "pt-BR", not "pt": DataForSEO's Gemini and AI Mode take only the former.
  { code: "pt-BR", label: "Portuguese (Brazil)" },
] as const;

/** "India", not "IN". A code is an identifier, not something to show a person. */
export function countryLabel(code: string): string {
  return COUNTRIES.find((country) => country.code === code)?.label ?? code;
}

/** The other half of a market. Same rule: "Hindi", not "hi". */
export function languageLabel(code: string): string {
  return LANGUAGES.find((language) => language.code === code)?.label ?? code;
}
